@if (chartService.showMap()) {
  <div class="d-flex pe-2 pb-2 bg-white">
    <highcharts-chart
      id="container"
      [constructorType]="chartService.chartConstructor"
      [options]="chartService.chartOptions"
      style="width: 100%; height: 400px; display: block" />
  </div>
}
